import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
    IEnviarMensagemAtiva,
    IMensagemTemplate,
} from "../../../Interfaces/HelpDesk/Equipes/Atendimento/AtendimentoInterfaces";
import { EnviarMensagemAtivaServices } from "../../../Services/HelpDesk/Atendimento/AtendimentoServices";
import {
    ListarIntegracaoWpp,
    ListarMensagensTemplate,
    ListarMensagensTemplateTwillio,
} from "../../../Services/HelpDesk/GestaoAtendimentos/GestaoAtendimentosService";
import { IError, ValidationErr } from "../../../Validations/ValidationError";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import { useAtedimento } from "../../../Context/Atendimento";
import { ACESSOS } from "../../../Routes/Acessos";
import { GetIntegracoesPorIdController } from "../../../Controllers/Geral/Integracao/IntegracoesController";

interface IuseWhatsappAtivo {
    setModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export function useWhatsappAtivo({ setModal }: IuseWhatsappAtivo) {
    //States
    const history = useHistory();
    const [lstMessage, setLstMessage] = useState<IMensagemTemplate[]>([]);
    const [inputShow, setInputShow] = useState<Boolean>(false);

    const { HELP_DESK } = useAtedimento();

    const { value: lstIntegracaoWpp } = useAsyncEffect(
        () =>
            ListarIntegracaoWpp(
                encodeURIComponent(HELP_DESK.equipe.NR_TELEFONE)
            ),
        [HELP_DESK.equipe.NR_TELEFONE]
    );

    const { value: lstMensagensTemplateTwillio } = useAsyncEffect(async () => {
        if (
            lstIntegracaoWpp?.data.DS_TIPO_INTEGRACAO?.toUpperCase() ===
            "TWILIO"
        ) {
            return ListarMensagensTemplateTwillio();
        }
    }, [lstIntegracaoWpp]);

    const { value: getIntegracoesPorId } = useAsyncEffect(async () => {
        if (
            lstIntegracaoWpp?.data.DS_TIPO_INTEGRACAO?.toUpperCase() ===
            "TWILIO"
        ) {
            return GetIntegracoesPorIdController(
                lstIntegracaoWpp?.data.ID_TIPO_INTEGRACAO
            );
        }
    }, [lstIntegracaoWpp]);

    async function SendMessage(props: IEnviarMensagemAtiva) {
        const body: IEnviarMensagemAtiva = {
            sid:
                lstIntegracaoWpp?.data.DS_TIPO_INTEGRACAO?.toUpperCase() ===
                    "META" && getIntegracoesPorId
                    ? null
                    : props.sid,
            numDestino: props.numDestino.replace(/\D/g, ""),
            ddiNumDestino: props.ddiNumDestino,
            idTemplate: props.idTemplate,
            VariaveisTemplate: props.VariaveisTemplate
        };
        if (props.numDestino) {
            await EnviarMensagemAtivaServices(body, true)
                .then((response) => {
                    if (response.status === 200) {
                        setModal(false);
                        history.push(
                            ACESSOS.HELPDESK.TELAS.ATENDIMENTO.DS_PATH
                        );
                    }
                })
                .catch((err) => {
                    ValidationErr(err);
                    throw err;
                });
        } else {
            ValidationErr({
                data: {
                    title: "Não foi possivel enviar a mensagem",
                    ErroInformal: "Por favor Digite um Telefone Valido",
                },
                status: 404,
            } as IError);
        }
    }

    async function lstMensagemTemplate() {
        await ListarMensagensTemplate()
            .then((response) => {
                if (response.status === 200) {
                    setLstMessage(response.data);
                }
            })
            .catch((err) => {
                ValidationErr(err);
                throw err;
            });
    }
    useEffect(() => {
        lstMensagemTemplate();
    }, []);
    return {
        SendMessage,
        lstMessage,
        inputShow,
        setInputShow,
        lstIntegracaoWpp,
        lstMensagensTemplateTwillio,
    };
}
